import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { first, Observable } from 'rxjs';
import { PITEventService, UtilsMisc } from '@pit/core';
import { EntityDataServiceAccessorService } from '@pit/core-data';
import { EntityStoreFacade } from '@pit/core-store';
import { IDtoDevice } from '@pit/frontend-model';
import { DtoDeviceStoreFactory } from './dto.device.store.factory';
import { IDtoDeviceEntityDataService } from '../../module.data/services/interfaces/dto.device.entity.data.service.interface';

@Injectable({
    providedIn: 'root'
})
export class DtoDeviceStoreFacade extends EntityStoreFacade<IDtoDevice> {

    constructor(store: Store<IDtoDevice>, dataServiceAccessor: EntityDataServiceAccessorService, eventService: PITEventService) {
        super(DtoDeviceStoreFactory.instance, store, 'DtoDevice', dataServiceAccessor, eventService);
    }

    public getDevicesSortedByAccount$(): Observable<IDtoDevice[]> {
        return this.store
            .select(this.entityStoreFactory.getSelector('get.devices.sorted.by.account'));
    }

    public getDevicesSortedByModifiedAt$(): Observable<IDtoDevice[]> {
        return this.store
            .select(this.entityStoreFactory.getSelector('get.devices.sorted.by.modifiedat'));
    }

    public getDeviceByDeviceId$(deviceId: string): Observable<IDtoDevice> {
        return this.store
            .select(this.entityStoreFactory.getSelector('get.by.deviceid')(deviceId));
    }

    public async getDeviceByDeviceIdAsync(deviceId: string): Promise<IDtoDevice> {
        let result: IDtoDevice = null;
        try {
            result = await this.getDeviceByDeviceId$(deviceId).pipe(first()).toPromise();
        } catch {
        }

        return result;
    }

    public loadDevicesForMandatorByDepot$(mandator: string, numberDepot: string): void {
        this.store.dispatch(this.entityStoreFactory.getAction('get.by.depot')({ mandator: mandator, numberDepot: numberDepot }));
    }

    public async loadDevicesForMandatorByDepotAsync(mandator: string, numberDepot: string, onlyWithShipments: boolean = false): Promise<IDtoDevice[]> {
        let result: IDtoDevice[] = null;
        try {
            const queryResult: IDtoDevice[] = await (this.dataServiceAccessor.getEntityDataService<IDtoDevice>(this.entityStoreFactory.dataAccessName.toLowerCase()) as IDtoDeviceEntityDataService).getDevicesForMandatorByDepotNumberAsync(mandator, numberDepot, onlyWithShipments);
            this.clear();
            if ((UtilsMisc.isNullOrUndefined(queryResult) === false) && (queryResult.length > 0)) {
                result = queryResult;
                this.upsertItemsToStore(result);
            }
        } catch (error) {
        } finally {
        }

        return result;
    }

}
